/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function ($) {
  $('.product-meta__technical ul').each(function() {
    var LiN = $(this).find('li').length;
    console.log(LiN);
    if (LiN > 10) {
      $('li', this).eq(9).nextAll().hide().addClass('toggleable');
      $(this).after('<a class="more-tech-spec button button-gray">Show More <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg></a>');
    }
  });

    $('.product-meta__technical').on('click', '.more-tech-spec', function() {
      if(!$(this + 'ul li.toggleable').hasClass('show')) { 
        $(this + 'ul li.toggleable').show().addClass('show');
        $('.more-tech-spec').html('Show Less <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"/></svg>');
      }else{
        $(this + "ul li.toggleable.show").hide().removeClass('show');
        $('.more-tech-spec').html('Show More <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg>');
      }    
    });
})




/* Cressi Africa 2026-09-29: lazysizes shim.
   Older custom sections (collection-with-image-custom, slideshow-*-news, etc.) use the
   lazysizes attributes data-bgset / data-src (with a {width} placeholder). The upgraded
   Warehouse theme no longer ships lazysizes, so those images never loaded. This resolves
   them directly. */
;(function () {
  function pickWidth(el, widths) {
    var w = Math.ceil((el.getBoundingClientRect().width || window.innerWidth) * (window.devicePixelRatio || 1));
    if (widths && widths.length) {
      for (var i = 0; i < widths.length; i++) if (widths[i] >= w) return widths[i];
      return widths[widths.length - 1];
    }
    return Math.min(Math.max(w, 400), 2000);
  }
  function applyBgset(el) {
    var parts = el.getAttribute('data-bgset').split(',');
    var chosen = null;
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim(), m = p.match(/^(\S+)(?:\s+\d+w)?(?:\s*\[([^\]]+)\])?/);
      if (!m) continue;
      var mq = m[2];
      if (mq === '--lap') mq = '(min-width: 1000px)';
      else if (mq === '--pocket') mq = '(max-width: 640px)';
      else if (mq && mq.indexOf('--') === 0) mq = null;
      if (!mq || window.matchMedia(mq).matches) { chosen = m[1]; break; }
      if (!chosen) chosen = null;
    }
    if (chosen) {
      el.style.backgroundImage = 'url("' + chosen.replace('{width}', pickWidth(el)) + '")';
      el.style.backgroundSize = el.style.backgroundSize || 'cover';
      el.style.backgroundPosition = el.style.backgroundPosition || 'center';
    }
    el.classList.add('lazyloaded');
  }
  function applySrc(img) {
    var src = img.getAttribute('data-src');
    var widths = null;
    try { widths = JSON.parse(img.getAttribute('data-widths') || 'null'); } catch (e) {}
    img.src = src.replace('{width}', pickWidth(img, widths));
    if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
    img.classList.add('lazyloaded');
  }
  function run() {
    if (window.lazySizes) return;
    document.querySelectorAll('[data-bgset]').forEach(applyBgset);
    document.querySelectorAll('img[data-src]:not([src])').forEach(applySrc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () {
    if (window.lazySizes) return;
    document.querySelectorAll('[data-bgset]').forEach(applyBgset);
  }, 250); });
  document.addEventListener('shopify:section:load', run);
})();
